import { checkAuthentication } from './middleware';

export const hospitalRoutes = [
    {
        path: '/hospitals',
        name: 'HospitalList',
        component:  () => import(/* webpackChunkName: "hospital-route" */ '../views/hospitals/HospitalList'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/hospitals/view/:id',
        name: 'ViewHospital',
        component: () => import(/* webpackChunkName: "hospital-route" */ '../views/hospitals/ViewHospital'),
        props: true,
        beforeEnter: checkAuthentication
    },
]